import { onUnmounted, watch } from 'vue';

export function useDisableBodyScroll(isScrollDisabled) {
  const scrollToTopButton = document.querySelector('.scroll-to-top-button');

  watch(isScrollDisabled, (newVal) => {
    if (newVal) {
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;

      // only do anything if the document naturally has a scrollbar
      if (scrollHeight > clientHeight) {
        // calculate padding width based off users browser settings
        const scrollbarWidth = getScrollbarWidth();
        document.body.style.paddingRight = `${scrollbarWidth -0.5}px`;

        if (scrollToTopButton) {
          scrollToTopButton.style.marginRight = `${scrollbarWidth -0.5}px`;
        }
        document.body.style.overflow = 'hidden';
      }
    } else {
      setTimeout(() => {
        document.body.style.overflow = 'auto';
        document.body.style.paddingRight = '';
        if (scrollToTopButton) {
          scrollToTopButton.style.marginRight = '';
        };
      }, 300);
    }
  });

  onUnmounted(() => {
    setTimeout(() => {
      document.body.style.overflow = 'auto';
      document.body.style.paddingRight = '';
      if (scrollToTopButton) {
        scrollToTopButton.style.marginRight = '';
      };
    }, 300);
  });
}

// Helper function to calculate scrollbar width
function getScrollbarWidth() {
  const outer = document.createElement('div');
  outer.style.visibility = 'hidden';
  outer.style.overflow = 'scroll';
  outer.style.width = '100px';
  outer.style.position = 'absolute';
  document.body.appendChild(outer);

  const inner = document.createElement('div');
  inner.style.width = '100%';
  outer.appendChild(inner);

  const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
  outer.parentNode.removeChild(outer);

  return scrollbarWidth;
}

